import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../components/site/Seo";
import { ProductCard, SectionHeader } from "../components/site/Cards";

export default function FreeTests() {
  const [products, setProducts] = useState([]);
  useSeo({ title: "Free Mock Tests | Agni Shiksha", description: "Attempt free full-length mock tests on the real exam interface — no payment required." });
  useEffect(() => {
    api.get("/products?limit=100").then((r) => setProducts(r.data.filter((p) => p.price === 0 || p.type === "Free Test"))).catch(() => {});
  }, []);
  return (
    <div className="container-px section-y">
      <SectionHeader eyebrow="Free Mock Tests" title="Experience the real exam — free" subtitle="Every free mock uses the same TCS-iON style interface, timer and analysis as our paid series." />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p) => <ProductCard key={p.id} p={p} />)}
      </div>
      {products.length === 0 && <div className="card-surface p-10 text-center text-content-muted">Free tests coming soon.</div>}
    </div>
  );
}
